import axios from 'axios';
import {
  IAccountShortCollection,
  IAddressShortCollection,
  ISubdivisionsShortCollection,
  IUserShortCollection,
} from 'common/models';
import {
  IDistributeRequestPayload,
  IRequest,
  ICancelRequestPayload,
  IRequestCollection,
  IRequestListPayload,
  IRequestDistributionCollection,
  IRequestMembers,
  IRequestStats,
} from 'entities/Request/Request.models';

const basePath = 'request';

export const requestTransport = {
  get: (payload: IRequestListPayload): Promise<IRequestCollection> => axios.post(`${basePath}/list`, payload),
  getById: (id: number): Promise<IRequest> => axios.get(`${basePath}/${id}`),
  cancel: (payload: ICancelRequestPayload): Promise<IRequest> => axios.patch(`${basePath}/cancel/${payload.id}`),
  getBuyers: (payload: IRequestListPayload): Promise<IAccountShortCollection> => axios.post(`${basePath}/buyers`, payload),
  getSubdivisions: (payload: IRequestListPayload): Promise<ISubdivisionsShortCollection> =>
    axios.post(`${basePath}/subdivisions`, payload),
  getUsers: (payload: IRequestListPayload): Promise<IUserShortCollection> => axios.post(`${basePath}/users`, payload),
  getAddresses: (payload: IRequestListPayload): Promise<IAddressShortCollection> => axios.post(`${basePath}/addresses`, payload),
  getStats: (payload: IRequestListPayload): Promise<IRequestStats> => axios.post(`${basePath}/stats`, payload),
  getMembers: (requestId: number): Promise<IRequestMembers> => axios.get(`${basePath}/members`, { params: { requestId } }),
  uploadExcel: (id: number): Promise<ArrayBuffer> => axios.get(`${basePath}/excel/${id}`, { responseType: 'arraybuffer' }),
  getDistributions: (id: number): Promise<IRequestDistributionCollection> => axios.get(`${basePath}/${id}/distribution`),
  distributeRequest: (payload: IDistributeRequestPayload): Promise<IRequestDistributionCollection> =>
    axios.post(`${basePath}/${payload.requestId}/distribution`, { items: payload.items }),
};
